import templateUrl from '../views/modals/add-ticket-template-modal.tpl.html';
import AddTicketTemplateModalController from '../controllers/modals/add-ticket-template-modal';

export default function addTicketTemplateModalCreator($injector) {
    return $injector.get('$uibModal')
        .open({
            controller: AddTicketTemplateModalController,
            controllerAs: 'vm',
            templateUrl,
            backdrop: 'static',
            size: 'lg',
            keyboard: false,
        })
        .result
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/helpers/add-ticket-template-modal-creator.js